import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  RoutesRecognized,
  UrlTree,
} from '@angular/router';
import { filter, Observable, pairwise } from 'rxjs';
import { FirestoreService } from 'src/app/shared/services/firestore.service';
// import { GMUser } from 'src/app/shared/interfaces/user';

@Injectable({
  providedIn: 'root',
})
export class CustomeruserguardGuard implements CanActivateChild {
  constructor(
    private firestoreService: FirestoreService,
    private router: Router
  ) {}

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    let url: string = state.url;
    return this.checkUserRole(next, url, state);
  }

  async checkUserRole(
    route: ActivatedRouteSnapshot,
    url: any,
    state: any
  ): Promise<boolean> {
    return new Promise(async (resolve) => {
      const res: any = await this.firestoreService.getAuthUserProfile();

      if (res && res.role) {
        if (res.role === 'customer') {
          resolve(true); // ✅ allow customer
        } else {
          // 🚦 Redirect based on role
          if (res.role === 'New User') {
            this.router.navigateByUrl('/');
          } else if (res.role === 'servicemanager') {
             this.router.navigateByUrl('/servicemanager');
          }  else if (res.role === 'productmanager') {
            this.router.navigateByUrl('/productmanager');
          } else if (res.role === 'admin') {
            this.router.navigateByUrl('/admin');
          }
          resolve(false);
        }
      } else {
        this.router.navigateByUrl('/');
        resolve(false);
      }
    });
  }
}
